const tooltips = {
  orszag: 'Ezen a felületen országokat lehet rögzíteni, adataikat karbantartani.',
  telepules: 'Ezen a felületen adott országhoz tartozó települések irányítószámát és a nevét lehet rögzíteni, karbantartani. Egy településhez több irányítószám is tartozhat, és ugyanaz az irányítószám tartozhat több településhez is.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
